import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Divider,
  SelectList,
} from "@tiny/components";

export interface SortOption {
  label: string;
  value: string[];
}

interface SortDialogProps {
  open: boolean;
  onClose: () => void;
  sortOptions: SortOption[];
  onSave: (sort: string[]) => void;
  sort: string[];
}

function SortDialog(props: SortDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} disableScrollLock>
      <SortDialogContent {...props} />
    </Dialog>
  );
}

function SortDialogContent(props: SortDialogProps) {
  const { onClose, sortOptions, sort, onSave } = props;

  const [internalSort, setInternalSort] = React.useState(sort);

  const save = () => {
    onSave(internalSort);
    onClose();
  };

  return (
    <>
      <DialogTitle>Filter by</DialogTitle>
      <DialogContent>
        <Divider mb={3} />
        <SelectList
          value={internalSort}
          options={sortOptions}
          onChangeValue={setInternalSort}
        />
        <Divider mt={3} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" fullWidth onClick={save}>
          Save
        </Button>
      </DialogActions>
    </>
  );
}

export default SortDialog;
